import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "_shared/contexts/AuthContext";
import styles from "./HeaderMessage.module.scss";

type Holiday = {
  date: string;
  title: string;
  halfDay?: boolean;
};

const HeaderMessage: React.FC = () => {
  const { isAuthenticated } = useAuth();
  let location = useLocation();

  const [intervalPlan, setIntervalPlan] = useState<"daily" | "intraday">();
  const [lastRefresh, setLastRefresh] = useState<Date | null>(null);
  const [showRefreshButton, setShowRefreshButton] = useState(false);

  const [currentHoliday, setCurrentHoliday] = useState<Holiday>();
  const [isWeekend, setIsWeekend] = useState<boolean>();

  useEffect(() => {
    if (!isAuthenticated) return;

    const getCurrentHoliday = async () => {
      const response = await API.get("public", "/cognito/isMarketOpen", {});
      setCurrentHoliday(response);
    };
    getCurrentHoliday();

    // TODO: user's interval plan should be abstracted
    const getUserPlan = async () => {
      const planRes = await API.graphql(
        graphqlOperation(`{
        user_subscriptions(where: {subscription_id: {_like: "%plan"}}) {
          frequency
        }
      }`),
      );
      // @ts-ignore -- issue with AWS Amplify types
      setIntervalPlan(planRes?.data!.user_subscriptions[0].frequency);
    };
    getUserPlan();

    // is it currently the weekend?
    const today = new Date();
    const day = today.getDay();
    setIsWeekend(day === 0 || day === 6);
  }, [isAuthenticated]);

  const checkRefresh = async () => {
    if (!lastRefresh) setLastRefresh(new Date());
    const now = new Date();
    const diff = now.getTime() - lastRefresh!.getTime();
    const diffInHours = Math.floor(diff / 1000 / 60 / 60);
    // show button if last refresh was more than an hour ago
    if (diffInHours >= 1) {
      setShowRefreshButton(true);
    }
    if (!intervalPlan || !lastRefresh) return;
    const lastRefreshHour = lastRefresh.getHours();
    const nowHour = now.getHours();
    if (
      // past 9am or 5pm on a weekday for daily plan
      (intervalPlan === "daily" && lastRefreshHour < 9 && nowHour >= 9) ||
      (lastRefreshHour <= 17 && nowHour > 17) ||
      // every hour between 8am and 6pm for intraday plan
      (intervalPlan === "intraday" &&
        nowHour >= 8 &&
        nowHour < 18 &&
        diffInHours >= 1)
    ) {
      setShowRefreshButton(true);
    }
  };

  // check if tickers require a refresh
  useEffect(() => {
    if (!isAuthenticated || !intervalPlan) return;
    const interval = setInterval(checkRefresh, 1000 * 60); // check every minute
    return () => clearInterval(interval);
  }, [isAuthenticated, intervalPlan]);

  // refresh on location change
  useEffect(() => {
    setLastRefresh(new Date());
  }, [location]);

  if (currentHoliday?.date) {
    <div>
      <i className="fas fa-clock"></i>
      <p style={{ display: "inline", fontSize: 14 }}>
        {currentHoliday.halfDay
          ? "The US Stock Market is closing early today due to "
          : "The US Stock Market is closed today due to "}
        <span style={{ textDecoration: "underline" }}>
          {currentHoliday.title}
        </span>
        . Longbow data including signal and range data, will be updated
        accordingly.
      </p>
    </div>;
  }
  if (isWeekend)
    return (
      <div className={styles.message} style={{ fontSize: 14 }}>
        <i className="fas fa-clock"></i>&nbsp; The US Stock Market is closed
        today. Longbow data including signal and range data, will be updated
        when the market opens.
      </div>
    );
  if (showRefreshButton)
    return (
      <button
        className={styles.reloadMessage}
        onClick={() => window.location.reload()}
      >
        <i className="fas fa-redo-alt"></i>
        &nbsp;Refresh to see updated data.
      </button>
    );
  return null;
};

export default HeaderMessage;
